export default "/images/register-2.png?68827366a51d875abdc49041ad82d940";